import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-testid"];
const _hoisted_2 = { class: "text-xs text-(--colors-text-error-strong)" };
import { useI18n } from "vue-i18n";
import { Button } from "@eudonet/opal";
/**
 * Shown by a Résumé widget whose own read failed. It replaces the widget's content rather than
 * its empty state: "we could not read this" and "there is nothing here" are different facts, and
 * a funding figure silently falling back to zero is the misleading one.
 */
export default /*@__PURE__*/ _defineComponent({
    __name: 'ResumeLoadError',
    props: {
        testid: {}
    },
    emits: ["retry"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const { t } = useI18n();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col items-center gap-2 rounded-xl border border-(--colors-border-error-subtle) bg-(--colors-background-error) px-3 py-4 text-center",
                "data-testid": __props.testid
            }, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)("projects.detail.resume.loadError")), 1 /* TEXT */),
                _createVNode(_unref(Button), {
                    variant: "secondary",
                    size: "sm",
                    label: _unref(t)('projects.detail.retry'),
                    "data-testid": `${__props.testid}-retry`,
                    onClick: _cache[0] || (_cache[0] = ($event) => (emit('retry')))
                }, null, 8 /* PROPS */, ["label", "data-testid"])
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
